<template>
  <div class="milestone-timeline" :class="[cssType, locale]">
    <!-- 竖向轨道：填充高度与 PC 横向进度条使用同一套 percent 计算 -->
    <div class="rail">
      <div class="rail-fill" :style="{ height: props.percent + '%' }"></div>
    </div>

    <div
      class="row"
      v-for="item in props.list"
      :key="item.rewardCode"
    >
      <div class="node-col">
        <div
          class="node"
          :class="{ done: item.status === 2, can: item.status === 1 }"
        ></div>
      </div>
      <div class="row-body">
        <div class="row-target">{{ $t('novShopping.milestone.spend', { n: item.targetSpent }) }}</div>
        <MilestoneCard :item="item" :activity-phase="props.activityPhase" @claim="$emit('claim', item)" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'
import { isMobile } from '@/utils'
import MilestoneCard from '../MilestoneCard/index.vue'

const props = defineProps({
  activityPhase: { type: String, default: 'loading' },
  list: {
    type: Array,
    default: () => [],
  },
  // 当前填充百分比（与 PC 横向进度条共用算法）
  percent: {
    type: Number,
    default: 0,
  },
})

defineEmits(['claim'])

const cssType = isMobile ? 'mobile' : 'pc'
const { locale } = useI18n()
</script>

<style lang="less" scoped src="./mobile_style.less"></style>
